import React from 'react';
import { Icon } from 'antd';

export const confirmCloseEditing = {
  title: 'Внимание',
  content:
    'Вы действительно хотите отменить редактирование исполнителя? Несохраненные данные будут удалены!',
  okText: 'Отменить изменения',
  cancelText: 'Отмена',
  className: 'modal-save-changes',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
  okButtonProps: {
    ghost: true,
    type: 'danger',
  },
  maskClosable: true,
  icon: <Icon style={{ color: '#f5222d' }} type="question-circle" />,
  closable: true,
  mask: true,
};

export const confirmCloseCreation = {
  title: 'Внимание',
  content:
    'Вы действительно хотите отменить создание исполнителя? Несохраненные данные будут удалены!',
  okText: 'Отменить создание',
  cancelText: 'Отмена',
  className: 'modal-save-changes',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
  okButtonProps: {
    ghost: true,
    type: 'danger',
  },
  maskClosable: true,
  icon: <Icon style={{ color: '#f5222d' }} type="question-circle" />,
  closable: true,
  mask: true,
};

export const confirmUpdate = {
  title: 'Внимание!',
  content: 'Вы действительно хотите сохранить внесенные изменения?',
  okText: 'Сохранить',
  className: 'modal-save-changes',
  cancelText: 'Отмена',
  maskClosable: true,
  icon: <Icon style={{ color: '#9b9b9b' }} type="question-circle" />,
  closable: true,
  mask: true,
};

export const confirmDelete = {
  title: 'Внимание',
  content:
    'Вы уверены, что хотите архивировать исполнителя? Он будет не активен для аккаунта.',
  okText: 'Архивировать',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
    type: 'primary',
  },
  okButtonProps: {
    style: { width: 176 },
  },
};

export const confirmRestoreArchive = {
  title: 'Внимание',
  content: 'Вы действительно хотите восстановить исполнителя?',
  okText: 'Восстановить',
  cancelText: 'Отмена',
  className: 'confirm-gray',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
  },
  okButtonProps: {
    style: { width: 176 },
  },
};
